// extracted by css-extract-rspack-plugin
export default {"container":"_65149fb6","content":"_4a0c6478","title":"_83b1e2b1","titleItalic":"_65c9806b","desktopSeparator":"_e25edafe","mobileSeparator":"_bfc203cc","button":"_d78ec227"};